// @flow
import AdvertisementTemplatePage from './AdvertisementTemplatePage'
import { connect } from 'react-redux'
import type { Store } from '../redux/ducks'
import _ from 'lodash'
import { initialize as initializeEdit } from './AdvertisementTemplatePage/EditFormContainer'
import { initialize as initializeAssignment } from './AdvertisementTemplatePage/AssignmentFormContainer'
import getJson from '../services/getJson'

function mapStateToProps(state: Store, ownProps: Object) {
  return {
    hideAssignmentForm:
      _.isEmpty(state.advertisementTemplateAssignment.advertisementTemplates) ||
      ownProps.action !== 'create',
    hideEditForm: !_.isEmpty(state.advertisementTemplateAssignment.advertisementTemplateIds),
    editFormCopyPath: state.advertisementTemplate.editFormCopyPath
  }
}

function mapDispatchToProps(dispatch: Function, ownProps: Object) {
  return {
    onInit: () => {
      getJson(
        ownProps.action === 'create'
          ? `/advertisement_templates/new_data`
          : `/advertisement_templates/${ownProps.id}/data`
      ).done((data: Object) => {
        initializeEdit(dispatch, data.editForm, ownProps.selectedAudienceIds || [])
        data.assignmentForm && initializeAssignment(dispatch, data.assignmentForm)
      })
    }
  }
}

const AdvertisementTemplatePageContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(AdvertisementTemplatePage)

export default AdvertisementTemplatePageContainer
